import React, { useState } from "react";
import './numpad.css';

const Numpad = ({ onNumberClick, bids = {}, isLoading }) => {
  const numbers = ['1','2','3','4','5','6','7','8','9','0'];

  const [activeBtn, setActiveBtn] = useState(null);

  const handleClick = (num) => {
    setActiveBtn(num);
    onNumberClick(num);
  };

  return (
    <div className="numpad-container">
      <div className="numpad-grid">
        {numbers.map((num) => {

          const hasBid = !!bids[num];

          return (
            <button
              key={num}
              onClick={() => handleClick(num)}
              disabled={isLoading}
              className={`numpad-btn ${activeBtn === num ? "active" : ""}`}
            >

              {hasBid && (
                <span className="numpad-badge">
                  {bids[num]?.points}
                </span>
              )}

              {num}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Numpad;